import { filter } from "lodash";
import { Icon } from "@iconify/react";
import { sentenceCase } from "change-case";
import { useEffect, useState } from "react";
import iconEdit2 from "@iconify/icons-eva/edit-2-outline";
import trash2Fill from "@iconify/icons-eva/trash-2-fill";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Table, Stack, Avatar, TableRow, TableBody, TableCell, Container, Typography, TableContainer, TextField, Button, RadioGroup, FormControlLabel, Radio, OutlinedInput, Chip, Checkbox, ListItemText, MenuItem, Select, FormControl, InputLabel } from "@mui/material";
// components
import Page from "src/components/Page";
import Scrollbar from "src/components/Scrollbar";
import SearchNotFound from "src/components/SearchNotFound";
import plusFill from "@iconify/icons-eva/plus-fill";

import axios from "axios";
import StringUtil from "src/utils/StringUtil";
import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import Label from "src/components/Label";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import Confirm from "src/components/common/ConfirmDialog";
import ChangeAdminPwdDialog from "src/components/dialogs/ChangeAdminPwdDialog";

const TABLE_HEAD = [
  { id: "realname", label: "姓名", alignRight: false }, 
  { id: "username", label: "账号", alignRight: false }, 
  { id: "role", label: "角色", alignRight: false }, 
  { id: "status", label: "状态", alignRight: false }, 
  { id: "createdAt", label: "创建时间", alignRight: false }, 
  { id: "操作" }
];

const moreMenus = [
  { title: "修改密码", icon: iconEdit2 },
  { title: "编辑", icon: iconEdit2 },
  { title: "删除", icon: trash2Fill },
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function SupplierAdmin() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [roles, setRoles] = useState([]);
  const [roleMap, setRoleMap] = useState([]);

  const [filter, setFilter] = useState({
    page: 1,
    size: 10,
    search: "",
  });

  const [action, setAction] = useState("");
  const [targetItem, setTaretItem] = useState({});
  const [form, setForm] = useState({
    username: "",
    password: "",
    password2: "",
    realname: "",
    roles: [],
    status: 1,
  });

  useEffect(() => {
    getRoles();
  }, []);

  function getRoles() {
    axios
      .post("/system/role/all", { page: 1, size: 1000 })
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          setRoles(data);
          const map = {};
          data.forEach((d) => {
            map[d.id] = d.name;
          });
          setRoleMap(map);
        } else {
          alert(msg);
        }
      })
      .catch((err) => {});
  }

  useEffect(() => {
    getItems();
  }, [filter]);

  function getItems() {
    axios
    .post("/system/admin/all", filter)
    .then((res) => {
      const { code, msg, data, count } = res.data;
      if (code === 1) {
        setItems(data);
        setTotal(count);
      } else {
        alert(msg);
      }
    })
    .catch((err) => {});
  }

  const handlePageChange = (event, value) => {
    const newPage = value;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      // navigate(`/user/detail/${row.uid}`);
      let _roles = [];
      if (row.roleIds) {
        _roles = row.roleIds.split(",").map((rid) => roles.find((role) => role.id == rid));
      }

      // console.log('_roles, ', row.roleIds, _roles)

      setTaretItem(row);
      setForm({
        ...form,
        username: row.username,
        password: "",
        password2: "",
        realname: row.realname,
        status: row.status,
        roles: _roles,
      });
      setAction("edit");
    } else if (type === "删除") {
      Confirm({
        message: `确定删除管理员 ${row.realname} 吗？`,
        onConfirm() {
          handleDelAdmin(row);
        },
      });
    } else if (type === "修改密码") {
      setTaretItem(row);
      setAction("changePwd");
    }
  };

  // dialog
  function handleRoleSelected(e) {
    console.log(e.target.value);

    setForm({
      ...form,
      roles: e.target.value,
    });
  }

  function handleAddItem() {
    setAction("add");
    setForm({
      username: "",
      password: "",
      password2: "",
      username: "",
      status: 1,
      roles: [],
    });
  }

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handleDelAdmin({ uid }) {
    axios
      .post("/system/admin/del", { uid })
      .then((res) => {
        const { code, msg } = res.data;
        if (code === 1) {
          setItems(items.filter((it) => it.uid !== uid));
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("添加或修改管理员失败: ", err);
      });
  }

  function handleDialogConfirm() {
    const { username, password, password2, realname } = form;
    if (!username || !realname) return alert("信息不全");

    const formData = { ...form };

    if (action === "edit") {
      formData.uid = targetItem.uid;
    } else {
      if (!password || !password2) return alert("密码必填");
      if (password !== password2) return alert("两次密码不一致");
    }

    formData.roleIds = form.roles.map((r) => r.id).join(",");
    delete formData.roles;

    axios
      .post(action === "add" ? "/system/admin/add" : "/system/admin/edit", formData)
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          if (action === "add") {
            setItems([...items, data]);
          } else if (action === "edit") {
            const item = items.find((b) => b.uid === targetItem.uid);
            Object.assign(item, form);
            setItems([...items]);
          }

          setAction("");
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("添加或修改管理员失败: ", err);
      });
  }

  const emptyRows = filter.size - items.length;
  const isUserNotFound = items.length === 0;

  return (
    <Page title="管理员列表">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            管理员列表
          </Typography>

          <Button variant="contained" to="add" startIcon={<Icon icon={plusFill} />} onClick={handleAddItem}>
            添加管理员
          </Button>
        </Stack>

        <Card>
          <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} onRefresh={getItems} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />
                <TableBody>
                  {items.map((row) => {
                    const { uid, avatar, username, mobile, realname, roleIds, createdAt, is_super, status } = row;
                    const isItemSelected = selected.indexOf(username) !== -1;

                    let roleName = "";
                    if (is_super) {
                      roleName = "超级管理员";
                    } else if (roleIds) {
                      roleName = roleIds
                        .split(",")
                        .map((rid) => roleMap[rid])
                        .join(", ");
                    }

                    return (
                      <TableRow hover key={uid} tabIndex={-1} role="checkbox" selected={isItemSelected}>
                        {/* <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleClick(event, uid)}
                            />
                          </TableCell> */}
                        <TableCell align="left">{realname}</TableCell>
                        {/* <TableCell component="th" scope="row">
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Avatar alt={username} src={avatar} />
                            <Typography variant="subtitle2" noWrap>
                              {username}
                            </Typography>
                          </Stack>
                        </TableCell> */}
                        <TableCell align="left">{username}</TableCell>
                        <TableCell align="left">{roleName}</TableCell>
                        <TableCell>
                          <Label variant="ghost" color={["default", "success"][status]}>
                            {["关闭", "开启"][status]}
                          </Label>
                        </TableCell>
                        <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
                        <TableCell align="right">
                          <MoreMenu spread menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 50 * emptyRows }}>
                      <TableCell colSpan={2} />
                    </TableRow>
                  )} */}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 5 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>

      <FormDialog title={action === "add" ? "添加管理员" : "修改管理员"} open={action === 'edit' || action === 'add'} onClose={() => setAction()} onConfirm={handleDialogConfirm}>
        <FormItem title="账号" required>
          <TextField fullWidth placeholder="账号" autoComplete="off" id="username" value={form.username} size="small" onChange={(e) => handleIptChange("username", e.target.value)} />
        </FormItem>

        {action === "add" && (
          <>
            <FormItem title="密码" required>
              <TextField fullWidth placeholder="密码" type="password" autoComplete="off" id="password" value={form.password} size="small" onChange={(e) => handleIptChange("password", e.target.value)} />
            </FormItem>

            <FormItem title="密码确认" required>
              <TextField fullWidth placeholder="密码确认" type="password" autoComplete="off" id="password2" value={form.password2} size="small" onChange={(e) => handleIptChange("password2", e.target.value)} />
            </FormItem>
          </>
        )}

        <FormItem title="姓名" required>
          <TextField fullWidth placeholder="姓名" autoComplete="off" id="realname" value={form.realname} size="small" onChange={(e) => handleIptChange("realname", e.target.value)} />
        </FormItem>

        <FormItem title="角色" required>
          <FormControl sx={{ m: 1, width: 300 }}>
            <InputLabel id="demo-multiple-checkbox-label">角色</InputLabel>
            <Select labelId="demo-multiple-checkbox-label" multiple value={form.roles} onChange={handleRoleSelected} input={<OutlinedInput label="Tag" />} renderValue={(selected) => selected.map((s) => s.name).join(", ")} MenuProps={MenuProps}>
              {roles.map((role) => (
                <MenuItem key={role.id} value={role}>
                  <Checkbox checked={!!form.roles.find((r) => r.id == role.id)} />
                  <ListItemText primary={role.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </FormItem>

        <FormItem title="状态" required>
          <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.status}>
            <FormControlLabel value={0} control={<Radio />} label="关闭" onChange={(e) => handleIptChange("status", e.target.value)} />
            <FormControlLabel value={1} control={<Radio />} label="开启" onChange={(e) => handleIptChange("status", e.target.value)} />
          </RadioGroup>
        </FormItem>
      </FormDialog>

      {action === 'changePwd' && <ChangeAdminPwdDialog open={true} admin={targetItem} onClose={() => setAction('')} />}
    </Page>
  );
}
